var _path, _path2, _path3, _rect, _rect2, _path4, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArtRegistered = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 328,
  height: 172,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h328v172H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#EBEFFE",
  fillRule: "evenodd",
  d: "M148.645 42.77c27.513-10.406 57.678-37.451 78.134-16.314 23.609 24.396 15.126 64.575-4.896 91.99-17.799 24.372-49.655 30.599-78.733 22.524-29.98-8.326-60.436-29.623-58.698-60.689 1.531-27.357 38.565-27.82 64.193-37.512",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#F8B24F",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 6,
  d: "m88 85.94 26.946-8.178M103 116.172l17.4-5.499M78 104.997l36.734-10.178"
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 70,
  height: 120,
  x: 119,
  y: 37.155,
  fill: "#3863F0",
  rx: 12,
  transform: "rotate(-10 119 37.155)"
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 62,
  height: 112,
  x: 123.634,
  y: 40.4,
  fill: "#fff",
  rx: 8,
  transform: "rotate(-10 123.634 40.4)"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2CBE96",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 8,
  d: "m152.644 88.823 10.153 4.734L175.647 66"
})), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
  width: 12,
  height: 4,
  x: 166.487,
  y: 139.463,
  fill: "#3863F0",
  rx: 2,
  transform: "rotate(-10 166.487 139.463)"
})));
export default SvgArtRegistered;